import classNames from "../../functions/classNames";

const STATUS_LABELS = {
  mapped: "Mapped",
  partial: "Partial",
  unmapped: "Unmapped",
  skipped: "Skipped",
};

export default function SegmentListItem({ segment, isSelected, onClick }) {
  const preview =
    segment.transcript?.slice(0, 60) + (segment.transcript?.length > 60 ? "…" : "");

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "w-full text-left rounded-lg border p-3 transition",
        isSelected
          ? "border-ramsalab-teal-blue bg-ramsalab-teal-blue/10"
          : "border-gray-200 dark:border-ramsalab-light-navy hover:bg-gray-50 dark:hover:bg-ramsalab-navy"
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs text-gray-500 dark:text-gray-400">
          {segment.start != null ? `${segment.start.toFixed(2)}s` : "—"}
        </span>
        <span
          className={classNames(
            "rounded px-1.5 py-0.5 text-xs font-medium",
            segment.mapping_status === "mapped"
              ? "bg-green-100 text-green-800"
              : segment.mapping_status === "partial"
              ? "bg-amber-100 text-amber-800"
              : "bg-gray-100 text-gray-600"
          )}
        >
          {segment.mapped_count}/{segment.word_count} · {STATUS_LABELS[segment.mapping_status]}
        </span>
      </div>
      <p className="mt-1 text-sm text-gray-900 dark:text-white line-clamp-2" dir="auto">
        {preview || "Empty segment"}
      </p>
    </button>
  );
}
